/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Select_Video_FileInputs */



/**
* | output |
* | --- |
* | "Please select a video file" |
*
* @param {Embed_Captions_Select_Video_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_select_video_file = /** @type {((inputs?: Embed_Captions_Select_Video_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Select_Video_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un fichier video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Videodatei aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите видеофайл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione un archivo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择一个视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイルを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक वीडियो फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um arquivo de vídeo.")
	return /** @type {LocalizedString} */ ("Please select a video file")
});